import { gsap } from "gsap";
import Cookies from "js-cookie";
import { addToCart, removeIdsFromCart } from "../helpers/cart";

export default class FreeProducts extends HTMLElement {
	constructor() {
		super();

		this.prop = "_freeProduct";
		this.cookieName = "_freeProductIgnore";

		const freeProducts = String(this.dataset.freeProducts);
		this.freeProductsJson = JSON.parse(freeProducts);
		this.init();
	}

	init() {
		document.addEventListener("cartChange", (e) => {
			this.checkFreeProducts();
		});
	}

	checkFreeProducts() {
		const Obj = this;

		const cartEmpty = window.Zero.Cart.stats.total == 0;
		if (cartEmpty) Obj.removeAllFreeProducts();
		else {
			Obj.freeProductsJson.forEach((product) => {
				Obj.validateFreeProduct(
					product,
					product.validation,
					window.Zero.Cart.items,
					() =>
						addToCart(product.id, product.quantity, {
							[Obj.prop]: true,
						}),
					() => removeIdsFromCart([product.id])
				);
			});
		}
	}

	validateFreeProduct(freeProduct, type, cart, add, remove) {
		const Obj = this;
		const freeProductsInCart = cart.filter((i) => freeProduct.id == i.id);
		const freeProductQuantityRight =
			freeProductsInCart.length > 0 &&
			parseInt(freeProductsInCart[0].quantity) >=
				parseInt(freeProduct.quantity);
		const ignoreFreeProduct = Obj.checkIgnoreFreeProduct(freeProduct);

		//Still called twice
		if (freeProductQuantityRight) return;

		if (type == "none") {
			if (!ignoreFreeProduct) add();
		} else if (type == "products-in-cart") {
			const cartHasValidationProducts =
				cart.filter((i) => {
					return (
						freeProduct.validationProducts.indexOf(
							i.product_id.toString()
						) != -1
					);
				}).length > 0;
			if (cartHasValidationProducts) {
				if (!freeProductQuantityRight && !ignoreFreeProduct) add();
			} else if (freeProductsInCart.length > 0) remove();
		}
	}

	checkIgnoreFreeProduct(freeProduct) {
		//Check if cookie exists, and if ID is in it
		return window.Cookiebot?.consented && (
			String(Cookies.get(this.cookieName))
				?.split("|")
				.indexOf(freeProduct.id) != -1);
	}

	removeAllFreeProducts() {
		const freeProductsToRemoveIds = window.Zero.Cart.items
			.filter(
				(product) => product.properties && product.properties[this.prop]
			)
			.map((product) => product.id);
		removeIdsFromCart(freeProductsToRemoveIds);
	}
}
